import { memo } from 'react';
import { Pressable } from 'react-native';

import { PressableIconProps } from './PressableIcon.types';
import Icon from '../Icon/Icon';
import useStyle from '../../hooks/useStyle';

function PressableIcon({
  name,
  color,
  gradient,
  iconWidth,
  iconHeight,
  onPress,
  testID,
  ...rest
}: PressableIconProps) {
  const style = useStyle(rest);

  return (
    <Pressable style={style} onPress={onPress} testID={testID || `pressable-icon-${name}`}>
      <Icon
        name={name}
        color={color}
        width={iconWidth}
        height={iconHeight}
        gradient={gradient}
      />
    </Pressable>
  );
}

export default memo(PressableIcon);
